import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListarDependenciasFuncionariosComponent } from './listar-dependencias-funcionarios.component';


const routes: Routes = [
  { path: '', component: ListarDependenciasFuncionariosComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ListarDependenciasFuncionariosRoutingModule { }
